import { Card, Skeleton } from '@zond/ui';
import React from 'react';

/**
 * Skeleton component shown while loading attendance chart data
 */
export function ReportAttendanceChartSkeleton() {
  return (
    <Card className="p-6">
      {/* Title and controls area */}
      <div className="flex justify-between items-center mb-6">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-9 w-32" />
      </div>

      {/* Chart placeholder */}
      <Skeleton className="h-[250px] w-full rounded-md" />
    </Card>
  );
}
